<template>    
    <div>
    <v-container fluid class="black py-0" :class="{'isCheckout': isCheckout}">
        <MainHeader :isCheckout="isCheckout" />                
    </v-container>        
    <v-container fluid class="ma-0 pt-0 pl-0 pr-0">        
        <div class="flag-line1"></div>
        <div class="flag-line2"></div>
    </v-container>
</div>
</template>

<script>
    import MainHeader from "../Header/MainHeader";

    export default {
        name: 'NavBar',
        props: ['isCheckout'],
        components: {
            MainHeader
        }
    }
</script>

<style scoped lang="scss">   
    .flag-line1 {
        background-color:#0074bd;
        height:6px
    }
    .flag-line2 {
        background-color:#ffed00;
        height:6px
    }
</style>
